﻿import { Cultures } from "../common";
import common = require("../common");
import context = require("../modules/context");

class Config {
    private static _formaters = [
        {
            name: 'phone--ca-us',
            format: x => {
                if (!x) return x;
                x = x.trim();
                const numeric = x.replace(/[^0-9]+/gi, "");
                if (numeric.length !== 10) return x;
                return numeric.replace(/(\d{3})(\d{3})(\d{4})/i, "$1 $2-$3");
            }
        } as common.ITextFormater,
        {
            name: 'postal-code--ca',
            format: x => {
                if (!x) return x;
                x = x.trim().toUpperCase();
                if (x.length !== 6) return x;
                return '{a} {b}'.replace('{a}', x.substr(0, 3)).replace('{b}', x.substr(3, 3));
            }
        } as common.ITextFormater
    ];

    constructor() {
        for (let i = 0; i < Config._formaters.length; i++) {
            const f = Config._formaters[i];
            this.textFormaters[f.name] = f;
        }
    }
    readonly textFormaters = {};
    readonly messages = {
        /** delai applique avant de dequeuer les messages. Generallement utilise dans 'Page.ts' */
        initialDelayMsBeforeDisplayQueuedMessages: 500,
        /** valeur par defaut pour la duree de vie d'un messages (lorsque common.IMessage::durationMs n'est pas NULL) */
        defaultMessageDurationSec: 300,
        /** valeur par defaut pour la duree de vie COURTE d'un messages (destine au message de success, lorsque common.IMessage::durationMs n'est pas NULL) */
        shortMessageDurationSec: 5,
        /** delai  applique entre chaque messages dequeues */
        delayMsBetweenMessagesOnDisplayQueuedMessages: 625,
        /** 
         * duree de l'animation de fermeture des messages.
         * ATTENTION!! doit etre relativement equal a la somme de $messagesManagerItemClosingDelayMs et de $messagesManagerItemClosingDurationMs dans Coti360\Frontend\styles\components\_messages-manager.scss
         **/
        closingDurationMs: 500,
        /** nombre de minutes au-dela duquel le message enqueuer n'est plus considere comme vivant */
        messageLiveDurationMinutes: 3,
        /** ressource: message avisant que la sauvegarde n'a pas ete effectuée. */
        notSavedMessage: 'Sauvegarde non effectuée',
        /** ressource: valeurs par defaut des titres des messages */
        defaultTitles: {
            info: () => 'Info',
            success: () => '',
            warning: () => context.culture.get() === Cultures.fr ? 'Attention' : 'Warning',
            error: () => context.culture.get() === Cultures.fr ? 'Erreur' : 'Error',
            notification: () => 'Notification'
        }
    };
    readonly loader = {
        defaultMaxDurationMs: 180 * 1000//== 3 min
    };
    readonly errors = {
        codes: {
            unknown: 0,
            system: 100,
            functional: 110,
            concurrency: 111,
            invalidToken: 120,
            expiredToken: 130,
            unauthorized: 140
        }
    };
}

export = new Config();